import { render, staticRenderFns } from "./ReportCardDetail.vue?vue&type=template&id=a9c11464&scoped=true"
import script from "./ReportCardDetail.vue?vue&type=script&lang=ts"
export * from "./ReportCardDetail.vue?vue&type=script&lang=ts"
import style0 from "./ReportCardDetail.vue?vue&type=style&index=0&id=a9c11464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c11464",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlanGateUpgradeState: require('/build/apps/legacy/components/Common/PlanGateUpgradeState.vue').default,EmptyState: require('/build/apps/legacy/components/Common/EmptyState.vue').default,UIReportCardGrade: require('/build/apps/legacy/components/Common/UI2/Grade/UIReportCardGrade.vue').default,ReportCardDimensionRow: require('/build/apps/legacy/components/Run/ReportCard/ReportCardDimensionRow.vue').default})
